// extracted by mini-css-extract-plugin
module.exports = {"container":"successor-notification_container__1rg3H","image":"successor-notification_image__1WkNW","moreImages":"successor-notification_moreImages__1n8Yp"};